



































































import type { Comment } from '@getaccept/lib-shared/src/contextual-commenting/types/comment';
import { IconSize, ParagraphSize } from '@getaccept/lib-ui';
import type { PropType } from '@vue/composition-api';
import { computed, defineComponent, ref } from '@vue/composition-api';
import { storeToRefs } from 'pinia';
import { t } from '../../helpers/translation.helper';
import type { Recipient } from '../../types/Recipient';
import type { User } from '../../users/types/user';
import { CommentsHelper } from '../helpers/comments.helper';
import { useContextualCommentingStore } from '../store/contextual-commenting.store';
import { CommentStatus } from '../types/comment-status';
import type { CurrentUser } from '../types/current-user';
import ConversationCard from '../conversation-card/components/ConversationCard.vue';

const All = 'All';
const Unresolved = 'Unresolved';
const Resolved = 'Resolved';

type Filter = typeof All | typeof Unresolved | typeof Resolved;

export default defineComponent({
  name: 'CommentHistory',
  components: { ConversationCard },
  props: {
    comments: {
      type: Array as PropType<Comment[]>,
      default: () => [],
    },
    currentUser: {
      type: Object as PropType<CurrentUser>,
      required: true,
    },
    recipients: {
      type: Array as PropType<Recipient[]>,
      required: true,
    },
    selectedId: {
      type: String,
      required: true,
    },
    sender: {
      type: Object as PropType<User>,
      required: true,
    },
    readOnly: {
      type: Boolean,
      default: false,
    },
    hideHeader: {
      type: Boolean,
      default: false,
    },
    commentsHidden: {
      type: Boolean,
    },
    showHideCommentsToggle: {
      type: Boolean,
    },
  },
  setup(props, { emit }) {
    const contextualCommentsFilterOptions = ref([
      { key: All, label: t('cc_all') },
      { key: Unresolved, label: t('cc_unresolved') },
      { key: Resolved, label: t('cc_resolved') },
    ]);

    const ascending = ref(true);
    const filter = ref<Filter>(All);

    const { hoverComment } = useContextualCommentingStore();
    const { hoveredCommentId } = storeToRefs(useContextualCommentingStore());

    const sortedComments = computed(() =>
      CommentsHelper.sortByCreatedAt(props.comments, ascending.value)
    );

    const filteredComments = computed(() => {
      if (filter.value === Unresolved) {
        return sortedComments.value.filter(comment =>
          [CommentStatus.Active, CommentStatus.Draft].includes(comment.status)
        );
      }

      if (filter.value === Resolved) {
        return sortedComments.value.filter(comment => comment.status === CommentStatus.Resolved);
      }

      return sortedComments.value;
    });

    const hasFilteredConversationCards = computed(() => filteredComments.value.length > 0);

    const clickOutside = (commentId: string) => {
      emit('click-outside', commentId);
    };

    return {
      ascending,
      contextualCommentsFilterOptions,
      filter,
      filteredComments,
      hasFilteredConversationCards,
      IconSize,
      ParagraphSize,
      hoverComment,
      hoveredCommentId,
      t,
      clickOutside,
    };
  },
});
